// extracted by mini-css-extract-plugin
export var icon = "_b8-3";
export var subtitle = "_b8-2";
export var title = "_b8-1";
export var value = "_b8-0";